export const translations = {
  it: {
    nav: {
      brand: "Deal Rating",
      home: "Analisi",
      history: "I miei report",
      plan: "Il mio piano",
      lang: "EN",
      signIn: "Accedi",
      signOut: "Esci",
      shortlist: "I miei report",
      digest: "Top 10",
    },
    hero: {
      eyebrow: "Provincia di Lecce · Brindisi · Taranto",
      title: "Analizza le offerte, trova il vero affare.",
      sub: "Incolla l’URL o il testo di un annuncio trovato sul web. Riceverai una scheda di valutazione oggettiva basata su dati OMI, normative regionali pugliesi e termini chiave (pajara, lamia, vincoli).",
      value1Label: "Punteggio affare",
      value1Value: "0–10 vs dati OMI",
      value2Label: "Rendita netta",
      value2Value: "IMU + condominio + manutenzione",
      value3Label: "Rischi identificati",
      value3Value: "Asta · vincoli · ruderi",
      panelEyebrow: "Inizia subito · Gratuito",
      panelFooter: "Nessuna registrazione richiesta per la prima analisi. Risultato in ~20 secondi.",
    },
    examples: {
      eyebrow: "Esempi di valutazione",
      title: "Guarda cosa scoprono i nostri report",
      sub: "Tre esempi di annunci analizzati: un affare, uno onesto, uno sopravvalutato. Clicca per leggere il report completo.",
      score: "Punteggio",
      cta: "Apri report",
      headlineFallback: "Report dettagliato disponibile — clicca per aprirlo.",
      status: {
        bargain: "Affare",
        fair: "In linea",
        overpriced: "Sopravvalutato",
      },
    },
    input: {
      tabUrl: "URL dell’annuncio",
      tabText: "Testo libero",
      placeholderUrl: "https://www.immobiliare.it/...",
      placeholderText: "Incolla qui titolo + descrizione dell’annuncio…",
      analyze: "Analizza annuncio",
      analyzing: "Analisi in corso…",
      hint: "Funziona con annunci da Immobiliare, Idealista, Subito, Casa.it, Gate-away, Green-Acres, JamesEdition, LuxuryEstate e altri.",
      errEmpty: "Inserisci un URL o un testo.",
      errFail: "Errore durante l’analisi.",
    },
    sheet: {
      title: "Scheda di Valutazione",
      offerStatus: "Stato offerta",
      score: "Punteggio totale",
      economic: "Analisi economica",
      omiLocal: "Prezzo locale stimato (OMI)",
      asking: "Prezzo richiesto",
      diff: "Differenza",
      ppsqm: "Prezzo al m²",
      surface: "Superficie",
      potential: "Uso potenziale",
      tech: "Nota tecnica",
      risks: "Rischi identificati",
      noRisks: "Nessun vincolo evidente nel testo.",
      bonuses: "Bonus rilevati",
      buildingBonus: "Bonus edificabilità",
      resourceBonus: "Bonus risorse",
      omiBonus: "Bonus OMI",
      rentalBonus: "Bonus rendita affitto",
      rules: {
        omi: "+4 punti se il prezzo richiesto è almeno il 20% sotto il valore OMI di riferimento per il comune.",
        building: "+4 punti se l'annuncio menziona elementi edificabili o di pregio: pajara, lamia, masseria, trullo, ruderi.",
        resource: "+2 punti se l'annuncio cita risorse: pozzo, cisterna, oliveto, vigneto, frutteto.",
        rental: "Fino a +3 punti in base al rendimento netto annuo migliore (locazione lunga o turistico): ≥10% → +3, ≥7% → +2, ≥5% → +1. Le stime turistiche «entroterra prudenti» non concorrono al bonus.",
        penalty: "−5 punti se l'annuncio segnala vincoli paesaggistici, archeologici, idrogeologici, o aree inedificabili.",
      },
      penalty: "Penalità vincoli",
      breakdown: "Composizione del punteggio",
      cynical: "Avviso del Senior Agent",
      savedAt: "Analizzato il",
      source: "Fonte",
      noScore: "n/d",
      unknown: "n/d",
      printPdf: "Stampa / PDF",
      printPdfLocked: "Sblocca per scaricare",
      freePreview: "Anteprima gratuita — la versione scaricabile richiede un credito o Premium.",
      unlockDownload: "Sblocca",
      share: "Condividi",
      disclaimerLabel: "Disclaimer",
      disclaimer:
        "Dati OMI, stime di costi (IMU, spese condominiali, manutenzione) e rendimenti hanno finalità informative e indicative. Non sostituiscono il parere di un professionista qualificato (notaio, geometra, commercialista, agente immobiliare abilitato). Verificare sempre presso fonti ufficiali (Catasto, Comune, Soprintendenza) prima di qualsiasi decisione di acquisto, vendita o locazione.",
    },
    status: {
      BARGAIN: "AFFARE",
      FAIR: "PREZZO EQUO",
      OVERPRICED: "SOPRAVVALUTATO",
    },
    history: {
      title: "Archivio Valutazioni",
      sub: "Tutti gli annunci analizzati, ordinati dal più recente.",
      empty: "Nessuna analisi salvata ancora.",
      filter: "Filtra per stato",
      all: "Tutti",
      open: "Apri",
      delete: "Elimina",
      confirm: "Eliminare questa analisi?",
      gateMessage:
        "L'archivio personale è riservato agli utenti registrati. Accedi gratuitamente per consultare e gestire i tuoi annunci analizzati e i report salvati.",
    },
    footer: {
      tag: "Dati OMI indicativi · Verificare sempre conformità urbanistica presso il Comune.",
      disclaimer:
        "Disclaimer: i dati OMI, le stime delle spese (IMU, condominio, manutenzione), i rendimenti e i punteggi mostrati su Deal Rating hanno finalità puramente informative e indicative. Non sostituiscono il parere di un professionista qualificato (notaio, geometra, commercialista, agente immobiliare abilitato). Prima di qualsiasi decisione di acquisto, vendita o locazione, si raccomanda di verificare i dati presso fonti ufficiali e di consultare un consulente di fiducia.",
      privacy: "Privacy",
      cities: "Città principali",
      resources: "Risorse",
      legal: "Legale",
    },
    cookie: {
      eyebrow: "Cookie e privacy",
      title: "Rispettiamo la tua privacy",
      body: "Utilizziamo cookie tecnici necessari al funzionamento del sito (sessione, autenticazione, bilanciamento del carico, lingua) e, previo tuo consenso, cookie analitici di terze parti per migliorare il servizio. Puoi cambiare idea in qualsiasi momento dalla pagina Privacy.",
      learnMore: "Leggi l'informativa completa",
      accept: "Accetta tutti",
      reject: "Rifiuta",
      essentialOnly: "Solo essenziali",
      default: "Default",
    },
    privacy: {
      back: "Torna alla home",
      navLabel: "Privacy",
      consent: {
        eyebrow: "Gestisci il tuo consenso",
        title: "Cookie analitici",
        body: "Puoi revocare o concedere in qualsiasi momento il consenso all'utilizzo di cookie analitici di terze parti (Google Analytics 4 e PostHog).",
        current: "Stato attuale",
        granted: "Consenso concesso",
        denied: "Consenso negato",
        notSet: "Non ancora impostato",
      },
    },
    seo: {
      lang: "it",
      home: {
        title: "Deal Rating — Valuta annunci immobiliari del Salento (Lecce · Brindisi · Taranto)",
        description: "Analizza in 20 secondi qualsiasi annuncio del Salento: punteggio 0–10 vs dati OMI, rendita netta, rischi e potenziale d'uso. Prima analisi gratuita, niente registrazione.",
      },
    },
    feed: {
      eyebrow: "Mappa interattiva",
      title: "I migliori affari del Salento, ora.",
      sub: "Solo annunci con punteggio ≥ 6 (categoria 🔥 AFFARE) — gli altri sono nascosti per default. Usa “Cerca online” per scaricare nuovi annunci dal web.",
      viewListing: "Annuncio",
      reportListing: "Segnala / Analizza",
      price: "Prezzo",
      refresh: "Reseed",
      searchLive: "Cerca online",
      legend: "Provincia",
      empty: "Nessun affare con punteggio ≥ 6 al momento. Clicca “Cerca online” per nuovi risultati.",
      count: (n) => `${n} affari sulla mappa`,
      crawling: "Cerco annunci freschi su Immobiliare…",
      crawlDone: (k) => `Ricerca completata: ${k} immobili scoperti.`,
      crawlEmpty: "Nessun nuovo risultato.",
      filterAll: "Tutto Salento",
      reviewing: "Genero la scheda di valutazione…",
      adminPrompt: "Token amministratore (vedi backend/.env → ADMIN_TOKEN).\nSarà ricordato in questo browser, lo inserisci solo la prima volta.",
      adminSaved: "Token salvato in questo browser.",
      adminReset: "Reimposta token admin",
      adminClearedToast: "Token admin dimenticato. Ti verrà richiesto al prossimo click.",
      adminNoneStored: "Nessun token salvato.",
      sortLabel: "Ordina",
      sort: {
        scoreDesc: "Punteggio (alto → basso)",
        scoreAsc: "Punteggio (basso → alto)",
        priceAsc: "Prezzo (min → max)",
        priceDesc: "Prezzo (max → min)",
        ppsqmAsc: "€/m² (min → max)",
        newest: "Più recenti",
      },
      minScoreLabel: "Punteggio min",
    },
    watchlist: {
      eyebrow: "Avvisi personalizzati",
      title: "Le tue ricerche salvate.",
      sub: "Imposta criteri per ricevere subito un avviso quando un nuovo annuncio combacia: città, prezzo massimo al m², punteggio minimo, status.",
      addBtn: "Crea avviso",
      checkNow: "Controlla ora",
      empty: "Nessun avviso salvato. Crea il tuo primo criterio qui sotto.",
      delete: "Elimina",
      matchesLabel: (n) => (n === 1 ? "1 corrispondenza" : `${n} corrispondenze`),
      form: {
        label: "Nome (es. Affari Otranto)",
        town: "Città (parziale)",
        max: "€/m² max",
        min: "Score min (0-10)",
        statuses: "Status",
        save: "Salva avviso",
        cancel: "Annulla",
        atLeastOne: "Imposta almeno un criterio.",
      },
      badge: "Match",
      onCardBadge: (label) => `Corrisponde a “${label}”`,
    },
    cost: {
      title: "Costo totale di acquisto",
      sub: "Quello che pagherai davvero al rogito — non solo il prezzo dell'annuncio. Imposte, notaio e agenzia inclusi.",
      askingPrice: "Prezzo annuncio",
      registry: "Imposta di registro",
      fixedDuties: "Imposte catastale + ipotecaria",
      fixedDutiesHint: "€50 + €50 (importo fisso per privati)",
      notary: "Notaio",
      agency: "Agenzia (3% + IVA)",
      agencyOn: "Con agenzia",
      agencyOff: "Senza agenzia",
      firstHomeOn: "Prima casa attiva",
      firstHomeOff: "Seconda casa",
      totalLabel: "Esborso totale",
      extraLabel: "Costi extra",
      disclaimer:
        "Stima orientativa per persone fisiche, calcolata sul prezzo annuncio (non sul valore catastale). Verifica sempre con il tuo notaio: la base imponibile può variare con il «prezzo-valore», e regimi agevolati IAP/coltivatore diretto modificano l'imposta sui terreni agricoli.",
    },
    rental: {
      title: "Analisi rendita da affitto",
      sub: "Stima del rendimento se compri per affittare. Due scenari: locazione lunga residenziale o affitto turistico breve — disponibile per ogni località, con un'indicazione della forza del mercato locale.",
      bonusLabel: "Punteggio rendita potenziale",
      baseRate: "Tariffa di riferimento",
      monthShort: "mese",
      longterm: "Locazione lunga",
      tourist: "Affitto turistico",
      netYield: "Rendimento netto annuo",
      grossYield: "Lordo",
      payback: "Ammortamento",
      paybackHint: "Anni per recuperare il prezzo dal solo affitto netto",
      years: "anni",
      monthlyGross: "Canone mensile lordo",
      annualGross: "Affitto annuo lordo",
      annualNet: "Affitto annuo netto",
      costsLabel: "costi",
      peakWeekly: "Settimana di alta stagione",
      seasonWeeks: "Settimane di stagione",
      weeks: "settimane",
      sourceTown: "Tariffa OMI per il comune",
      sourceTownPartial: "Tariffa OMI per zona simile",
      sourceProvince: "Media provinciale (comune non in tabella)",
      tierStrong: "Mercato turistico forte",
      tierModerate: "Mercato turistico moderato",
      tierBaseline: "Stima prudente entroterra",
      disclaimerLongterm:
        "Stima indicativa basata su tariffe OMI residenziali. Costi del 20% includono IMU/TARI, manutenzione ordinaria, vacancy media e gestione. Verifica le tariffe locali con un'agenzia di zona prima di investire.",
      disclaimerTourist:
        "Stima conservativa: alta stagione + 6 settimane di spalla al 50%. Costi del 35% includono pulizie, commissioni piattaforme (Airbnb/Booking ~15-18%), utenze, IMU, cedolare secca. Fuori stagione conteggiato a zero — sii prudente con i numeri.",
      disclaimerTouristBaseline:
        "Stima conservativa per località dell'entroterra: 10 settimane di stagione a 1,5× la tariffa lunga, più 6 di spalla al 50%. Il mercato esiste (B&B, agriturismo, turismo lento) ma è meno intenso della costa. Verifica con un'agenzia locale.",
    },
    share: {
      back: "← Torna alla home",
      notFound: "Questa scheda non esiste più o l'ID non è valido.",
      error: "Errore nel caricamento.",
      loading: "Caricamento scheda…",
      copied: "Link copiato negli appunti.",
      failed: "Condivisione non riuscita.",
    },
    shortlist: {
      title: "I miei annunci salvati",
      sub: "Gli annunci che hai messo da parte. Snapshot del prezzo e del punteggio al momento del salvataggio.",
      empty: "Nessun annuncio salvato. Clicca l'icona segnalibro su una scheda del feed per iniziare.",
      saveBtn: "Salva",
      savedBtn: "Salvato",
      remove: "Rimuovi",
      loginRequired: "Accedi per salvare i tuoi annunci preferiti.",
      savedToast: "Aggiunto ai salvati.",
      removedToast: "Rimosso dai salvati.",
    },
    digest: {
      eyebrow: "Top 10 · Aggiornato settimanalmente",
      title: "Gli affari del Salento, classificati.",
      sub: "I dieci annunci con il punteggio più alto in questo momento. Selezionati dall'IA, basati su dati OMI, ordinati per qualità dell'affare.",
      updatedAt: "Aggiornato",
      shareTitle: "Top 10 Affari del Salento",
      shareBtn: "Condividi la lista",
      fullFeed: "Vedi tutto il feed",
      empty: "Ancora nessun annuncio con punteggio ≥ 8 nel feed. Clicca «Cerca online» nella home per scoprirne di nuovi.",
      scatterEyebrow: "Vista a due assi",
      scatterTitle: "Affare × Rendita — dove vincono entrambe?",
      scatterSub: "Ogni punto è un annuncio del feed. In alto a destra c'è la zona dolce: qualità dell'affare alta E potenziale rendita alta. La maggior parte degli annunci sta sull'asse orizzontale — un punteggio rendita > 0 è già raro.",
      scatterX: "Punteggio affare",
      scatterY: "Rendita potenziale",
      scatterSweetSpot: "Zona dolce (≥ 7 affare, ≥ 2 rendita)",
      scatterShareBtn: "Condividi grafico",
      scatterShareTitle: "Salento — Affare × Rendita",
    },
    condo: {
      eyebrow: "Stima spese condominiali",
      title: "Spese condominiali previste",
      monthly: "Mensile (stimato)",
      annual: "Annuale (stimato)",
      toggleLabel: "Per questo immobile sono previste spese condominiali?",
      toggleYes: "Previste",
      toggleNo: "Non previste",
      excludedTitle: "Spese condominiali non previste",
      excludedBody:
        "Immobile indipendente (casa singola, villa o trullo senza condominio). La rendita e il cashflow vengono aggiornati senza la voce di spesa condominiale.",
      tier: {
        small: "Piccolo condominio",
        standard: "Condominio standard",
        lift: "Con ascensore",
        amenities: "Con servizi condivisi",
        premium: "Residence costiero",
      },
    },
    imu: {
      eyebrow: "Stima IMU annuale",
      title: "IMU prevista (seconda casa)",
      annual: "IMU annuale (stimata)",
      valoreCatastale: "Base imponibile (stimata)",
      aliquota: "aliquota Salento",
    },
    netYield: {
      eyebrow: "Rendimento netto reale",
      title: "Net Yield combinato",
      yield: "Rendimento netto",
      gross: "Affitto lordo annuo",
      totalCosts: "Costi annuali totali",
      net: "Affitto netto annuo",
      payback: "Ammortamento",
      years: "anni",
      imu: "IMU",
      condo: "Spese condominiali",
      maintenance: "Manutenzione",
      vacancy: "Sfitto",
      management: "Gestione",
    },
    quota: {
      guestRemaining: "Hai 1 analisi gratuita di prova.",
      guestRegisterPrompt: "Registrati gratis per sbloccare più report completi.",
      guestExhausted: "Hai esaurito la prova gratuita. Registrati gratis per sbloccare più report completi.",
      userRemaining: "Ti restano ancora {n} analisi gratuite dettagliate.",
      userExhausted: "Hai esaurito i report gratuiti. Acquista un nuovo report a €1.99 oppure passa a Premium per report illimitati.",
      creditsRemaining: "Hai {n} credito/i report disponibili. Passa a Premium per non doverli più ricaricare.",
      registerCta: "Registrati",
      unlockCta: "Sblocca",
      upgradeCta: "Premium",
      premiumActive: "Premium · Report illimitati",
    },
    plan: {
      eyebrow: "Area personale",
      title: "Il mio piano",
      sub: "Riepilogo del tuo piano, dei report consumati e delle opzioni di upgrade / rinnovo.",
      loading: "Caricamento del piano…",
      gateMessage:
        "Accedi al tuo account per consultare i dettagli del tuo piano, i report disponibili e i crediti acquistati.",
      // Free tier
      freeEyebrow: "Piano attuale",
      freeTitle: "Piano Free",
      freeSub: "3 report dettagliati gratuiti, gli ulteriori sono acquistabili a credito o con Premium.",
      reportsRemaining: "Report ancora disponibili",
      creditsAvailable: "credito/i",
      exhaustedWarn:
        "Hai esaurito i 3 report gratuiti. Acquista un singolo credito a €1.99 o passa al piano Premium per report illimitati.",
      // Premium tier
      premiumActiveEyebrow: "Piano attivo",
      premiumActiveTitle: "Piano Premium",
      premiumActiveSub: "Report illimitati e scaricabili in PDF per la durata dell'abbonamento.",
      expires: "Scadenza",
      daysLeft: "giorni rimasti",
      expiresToday: "Scade oggi",
      // Sections
      upgradeSection: "Opzioni di upgrade",
      renewSection: "Rinnova il tuo piano",
      renewBadge: "Rinnovo",
      renewCta: "Rinnova Premium",
      // Stats footer
      reportsUsed: "Report consumati",
      creditsBalance: "Crediti residui",
      daysLeftShort: "Giorni residui",
      freeRemainingShort: "Free residui",
    },
    paywall: {
      eyebrow: "Sblocca report illimitati",
      title: "Hai bisogno di un altro report?",
      sub: "Acquista un singolo credito o passa al piano Premium — ideale per investitori e agenti che valutano decine di annunci al giorno.",
      guestEyebrow: "Hai esaurito la prova gratuita",
      guestTitle: "Registrati gratis · 3 report extra",
      guestSub: "Crea un account gratuito (login con Google) e sblocca subito 3 valutazioni dettagliate aggiuntive — senza inserire la carta.",
      registerFreeCta: "Registrati Gratis",
      creditEyebrow: "Singolo credito",
      creditTitle: "1 report dettagliato",
      creditSub: "Sbloccato all'istante · Scaricabile in PDF",
      creditUnit: "una tantum",
      creditCta: "Acquista 1 report",
      premiumBadge: "Consigliato",
      premiumEyebrow: "Piano Premium",
      premiumTitle: "Report illimitati · 30 giorni",
      premiumSub: "Per investitori e agenti · Tutti scaricabili in PDF",
      premiumUnit: "/ mese",
      premiumCta: "Diventa Premium",
      loading: "Reindirizzamento…",
      failed: "Impossibile avviare il pagamento. Riprova.",
      loginFirst: "Accedi prima di acquistare crediti o Premium.",
      footer: "Pagamento sicuro tramite Stripe · Disdici quando vuoi dal Customer Portal.",
    },
    billing: {
      eyebrow: "Pagamento",
      checking: "Verifica del pagamento…",
      successCredit: "Pagamento riuscito. Hai 1 credito report in più.",
      successPremium: "Premium attivato. Report illimitati per 30 giorni.",
      cancelled: "Pagamento annullato.",
      expired: "Sessione di pagamento scaduta. Riprova.",
      missingSession: "ID sessione mancante.",
      stillPending: "Pagamento ancora in elaborazione. Controlla l'email di conferma.",
      failed: "Errore durante la verifica del pagamento.",
      backHome: "Torna alla home",
    },
  },
  en: {
    nav: {
      brand: "Deal Rating",
      home: "Analyse",
      history: "My reports",
      plan: "My plan",
      lang: "IT",
      signIn: "Sign in",
      signOut: "Sign out",
      shortlist: "My reports",
      digest: "Top 10",
    },
    hero: {
      eyebrow: "Lecce · Brindisi · Taranto Provinces",
      title: "Analyze the offers, find the real deal.",
      sub: "Paste a listing URL or text. Get an objective evaluation sheet grounded in OMI data, Apulian regulations and key terms (pajara, lamia, restrictions).",
      value1Label: "Deal score",
      value1Value: "0–10 vs OMI data",
      value2Label: "Net yield",
      value2Value: "IMU + condo + maintenance",
      value3Label: "Risks flagged",
      value3Value: "Auction · liens · ruins",
      panelEyebrow: "Get started · Free",
      panelFooter: "No sign-up needed for your first analysis. Result in ~20 seconds.",
    },
    examples: {
      eyebrow: "Example evaluations",
      title: "See what our reports surface",
      sub: "Three example listings analysed: a bargain, an honest deal, and an overrated one. Click any card to read the full report.",
      score: "Score",
      cta: "Open report",
      headlineFallback: "Detailed report available — click to open.",
      status: {
        bargain: "Bargain",
        fair: "Fair",
        overpriced: "Overpriced",
      },
    },
    input: {
      tabUrl: "Listing URL",
      tabText: "Free text",
      placeholderUrl: "https://www.immobiliare.it/...",
      placeholderText: "Paste the listing title and description here…",
      analyze: "Analyse listing",
      analyzing: "Analysing…",
      hint: "Works with listings from Immobiliare, Idealista, Subito, Casa.it, Gate-away, Green-Acres, JamesEdition, LuxuryEstate and more.",
      errEmpty: "Provide a URL or some text.",
      errFail: "Analysis failed.",
    },
    sheet: {
      title: "Evaluation Sheet",
      offerStatus: "Offer status",
      score: "Total score",
      economic: "Economic analysis",
      omiLocal: "Local OMI estimate",
      asking: "Asking price",
      diff: "Difference",
      ppsqm: "Price per sqm",
      surface: "Surface",
      potential: "Potential use",
      tech: "Technical note",
      risks: "Identified risks",
      noRisks: "No restrictions detected in the text.",
      bonuses: "Detected bonuses",
      buildingBonus: "Building bonus",
      resourceBonus: "Resource bonus",
      omiBonus: "OMI bonus",
      rentalBonus: "Rental yield bonus",
      rules: {
        omi: "+4 points when the asking price is at least 20% below the OMI reference value for the town.",
        building: "+4 points when the listing mentions buildable / heritage features: pajara, lamia, masseria, trullo, ruins.",
        resource: "+2 points when the listing mentions resources: well, cistern, olive grove, vineyard, orchard.",
        rental: "Up to +3 points based on the best net annual yield (long-term or tourist): ≥10% → +3, ≥7% → +2, ≥5% → +1. Conservative inland tourist estimates don't count toward the bonus.",
        penalty: "−5 points when the listing flags landscape, archaeological or hydrogeological constraints, or non-buildable areas.",
      },
      penalty: "Restriction penalty",
      breakdown: "Score breakdown",
      cynical: "Senior Agent's warning",
      savedAt: "Analysed on",
      source: "Source",
      noScore: "n/a",
      unknown: "n/a",
      printPdf: "Print / PDF",
      printPdfLocked: "Unlock to download",
      freePreview: "Free preview — downloadable version requires a credit or Premium.",
      unlockDownload: "Unlock",
      share: "Share",
      disclaimerLabel: "Disclaimer",
      disclaimer:
        "OMI data, cost estimates (IMU, condominium fees, maintenance) and yields are purely informational and indicative. They do not replace the opinion of a qualified professional (notary, surveyor, accountant, licensed real-estate agent). Always verify against official sources (Catasto, Comune, Soprintendenza) before any decision to buy, sell, or rent.",
    },
    status: {
      BARGAIN: "BARGAIN",
      FAIR: "FAIR PRICE",
      OVERPRICED: "OVERPRICED",
    },
    history: {
      title: "Evaluation Archive",
      sub: "All listings you've analysed, most recent first.",
      empty: "No analyses saved yet.",
      filter: "Filter by status",
      all: "All",
      open: "Open",
      delete: "Delete",
      confirm: "Delete this analysis?",
      gateMessage:
        "Your personal archive is reserved for registered users. Sign in for free to consult and manage your analysed listings and saved reports.",
    },
    footer: {
      tag: "OMI data indicative · Always verify planning compliance with the Comune.",
      disclaimer:
        "Disclaimer: the OMI data, cost estimates (IMU, condominium fees, maintenance), yields, and scores shown on Deal Rating are purely informational and indicative. They do not replace the opinion of a qualified professional (notary, surveyor, accountant, licensed real-estate agent). Before any decision to buy, sell, or rent, please verify the figures against official sources and consult a trusted advisor.",
      privacy: "Privacy",
      cities: "Main cities",
      resources: "Resources",
      legal: "Legal",
    },
    cookie: {
      eyebrow: "Cookies & privacy",
      title: "We respect your privacy",
      body: "We use essential cookies needed to run the site (session, authentication, load-balancing, language) and, with your consent, third-party analytics cookies to improve the service. You can change your mind any time from the Privacy page.",
      learnMore: "Read the full policy",
      accept: "Accept all",
      reject: "Reject",
      essentialOnly: "Essential only",
      default: "Default",
    },
    privacy: {
      back: "Back to home",
      navLabel: "Privacy",
      consent: {
        eyebrow: "Manage your consent",
        title: "Analytics cookies",
        body: "You can grant or revoke your consent for third-party analytics cookies (Google Analytics 4 and PostHog) at any time.",
        current: "Current state",
        granted: "Consent granted",
        denied: "Consent denied",
        notSet: "Not set yet",
      },
    },
    seo: {
      lang: "en",
      home: {
        title: "Deal Rating — Score real-estate listings in Salento (Lecce · Brindisi · Taranto)",
        description: "Analyse any Salento property listing in 20 seconds: 0–10 score vs OMI data, net yield, risks and potential use. First analysis free, no signup required.",
      },
    },
    feed: {
      eyebrow: "Interactive map",
      title: "The best Salento deals, right now.",
      sub: "Only listings scoring ≥ 6 (🔥 BARGAIN tier) — the rest are hidden by default. Hit “Search live” to crawl Immobiliare for fresh results.",
      viewListing: "Listing",
      reportListing: "Report Listing",
      price: "Price",
      refresh: "Reseed",
      searchLive: "Search live",
      legend: "Province",
      empty: "No deals scoring ≥ 6 right now. Click “Search live” to find new ones.",
      count: (n) => `${n} deals on the map`,
      crawling: "Crawling Immobiliare for fresh listings…",
      crawlDone: (k) => `Crawl complete: ${k} listings discovered.`,
      crawlEmpty: "No new results.",
      filterAll: "All Salento",
      reviewing: "Running full AI review…",
      adminPrompt: "Admin token (see backend/.env → ADMIN_TOKEN).\nIt will be remembered in this browser — you only enter it once.",
      adminSaved: "Token saved in this browser.",
      adminReset: "Reset admin token",
      adminClearedToast: "Admin token forgotten. You'll be prompted again on the next admin click.",
      adminNoneStored: "No token stored yet.",
      sortLabel: "Sort",
      sort: {
        scoreDesc: "Score (high → low)",
        scoreAsc: "Score (low → high)",
        priceAsc: "Price (low → high)",
        priceDesc: "Price (high → low)",
        ppsqmAsc: "€/sqm (low → high)",
        newest: "Newest",
      },
      minScoreLabel: "Min score",
    },
    watchlist: {
      eyebrow: "Custom alerts",
      title: "Your saved searches.",
      sub: "Set criteria so we flag a listing the moment it matches: town, max €/m², min score, status.",
      addBtn: "Create alert",
      checkNow: "Check now",
      empty: "No saved alerts yet. Create your first criterion below.",
      delete: "Delete",
      matchesLabel: (n) => (n === 1 ? "1 match" : `${n} matches`),
      form: {
        label: "Name (e.g. Otranto Bargains)",
        town: "Town (partial)",
        max: "Max €/m²",
        min: "Min score (0-10)",
        statuses: "Status",
        save: "Save alert",
        cancel: "Cancel",
        atLeastOne: "Set at least one criterion.",
      },
      badge: "Match",
      onCardBadge: (label) => `Matches “${label}”`,
    },
    cost: {
      title: "Total acquisition cost",
      sub: "What you actually wire at closing — not just the listing price. Taxes, notary and agency included.",
      askingPrice: "Listing price",
      registry: "Registration tax",
      fixedDuties: "Mortgage + cadastral duty",
      fixedDutiesHint: "€50 + €50 (flat for private buyers)",
      notary: "Notary",
      agency: "Agency (3% + VAT)",
      agencyOn: "With agency",
      agencyOff: "No agency",
      firstHomeOn: "First-home relief on",
      firstHomeOff: "Second home",
      totalLabel: "Total outlay",
      extraLabel: "Extra costs",
      disclaimer:
        "Indicative estimate for individuals, calculated on the listing price (not the cadastral value). Always confirm with your notary: the taxable base can shift via the «prezzo-valore» rule, and IAP / coltivatore-diretto reliefs change the tax on agricultural land.",
    },
    rental: {
      title: "Rental income analysis",
      sub: "What you'd earn if you buy to rent. Two scenarios: long-term residential lease, or tourist short-term let — available for every town, with a tag showing the strength of the local market.",
      bonusLabel: "Potential rental income score",
      baseRate: "Reference rate",
      monthShort: "mo",
      longterm: "Long-term lease",
      tourist: "Tourist short-term",
      netYield: "Net annual yield",
      grossYield: "Gross",
      payback: "Payback",
      paybackHint: "Years to recoup the purchase price from net rent alone",
      years: "years",
      monthlyGross: "Monthly gross rent",
      annualGross: "Annual gross rent",
      annualNet: "Annual net rent",
      costsLabel: "costs",
      peakWeekly: "Peak summer week",
      seasonWeeks: "High-season weeks",
      weeks: "weeks",
      sourceTown: "OMI rate for this town",
      sourceTownPartial: "OMI rate for similar zone",
      sourceProvince: "Province average (town not in table)",
      tierStrong: "Strong tourist market",
      tierModerate: "Moderate tourist market",
      tierBaseline: "Conservative inland estimate",
      disclaimerLongterm:
        "Indicative estimate based on OMI residential rates. The 20% cost ratio covers IMU/TARI, ordinary maintenance, average vacancy and management. Verify local rates with a regional agency before investing.",
      disclaimerTourist:
        "Conservative estimate: high season + 6 shoulder weeks at 50%. The 35% cost ratio covers cleaning/turnover, platform fees (Airbnb/Booking ~15-18%), utilities, IMU, cedolare secca. Off-season counted as zero — be prudent with these numbers.",
      disclaimerTouristBaseline:
        "Conservative inland estimate: 10 high-season weeks at 1.5× the long-term rate plus 6 shoulder weeks at 50%. The market exists (B&Bs, agriturismo, slow tourism) but is thinner than the coast. Cross-check with a local agency.",
    },
    share: {
      back: "← Back to home",
      notFound: "This sheet no longer exists or the ID is invalid.",
      error: "Failed to load.",
      loading: "Loading sheet…",
      copied: "Link copied to clipboard.",
      failed: "Could not share.",
    },
    shortlist: {
      title: "My saved listings",
      sub: "Listings you've bookmarked. Price + score snapshotted at save time.",
      empty: "Nothing saved yet. Hit the bookmark icon on a feed card to start your shortlist.",
      saveBtn: "Save",
      savedBtn: "Saved",
      remove: "Remove",
      loginRequired: "Sign in to save your favourite listings.",
      savedToast: "Added to your shortlist.",
      removedToast: "Removed from your shortlist.",
    },
    digest: {
      eyebrow: "Top 10 · Refreshed weekly",
      title: "The Salento deals, ranked.",
      sub: "The ten highest-scoring listings right now. Selected by AI, grounded in OMI data, ordered by deal quality.",
      updatedAt: "Updated",
      shareTitle: "Top 10 Salento Bargains",
      shareBtn: "Share the list",
      fullFeed: "View full feed",
      empty: "No listings with score ≥ 8 in the feed yet. Hit «Search live» on the home page to discover fresh deals.",
      scatterEyebrow: "Two-axis view",
      scatterTitle: "Deal × Yield — where do both win?",
      scatterSub: "Each dot is a feed listing. The top-right is the sweet spot: high deal quality AND high rental potential. Most listings sit on the horizontal axis — a rental score > 0 is already rare.",
      scatterX: "Deal score",
      scatterY: "Rental potential",
      scatterSweetSpot: "Sweet spot (≥ 7 deal, ≥ 2 rental)",
      scatterShareBtn: "Share chart",
      scatterShareTitle: "Salento — Deal × Yield",
    },
    condo: {
      eyebrow: "Estimated condo fees",
      title: "Estimated condo fees",
      monthly: "Monthly (estimated)",
      annual: "Annual (estimated)",
      toggleLabel: "Does this property have condo fees?",
      toggleYes: "Yes",
      toggleNo: "No",
      excludedTitle: "No condo fees",
      excludedBody:
        "Standalone property (detached house, villa or trullo with no shared building). Rental yield and cashflow are updated without the condo line.",
      tier: {
        small: "Small condo",
        standard: "Standard condo",
        lift: "With lift",
        amenities: "With shared amenities",
        premium: "Coastal residence",
      },
    },
    imu: {
      eyebrow: "Estimated annual IMU",
      title: "Annual IMU (second home)",
      annual: "Annual IMU (estimated)",
      valoreCatastale: "Tax base (estimated)",
      aliquota: "Salento rate",
    },
    netYield: {
      eyebrow: "Realistic net yield",
      title: "Combined Net Yield",
      yield: "Net yield",
      gross: "Annual gross rent",
      totalCosts: "Total annual costs",
      net: "Annual net rent",
      payback: "Payback period",
      years: "years",
      imu: "IMU",
      condo: "Condo fees",
      maintenance: "Maintenance",
      vacancy: "Vacancy",
      management: "Management",
    },
    quota: {
      guestRemaining: "You have 1 free trial analysis.",
      guestRegisterPrompt: "Register for free to unlock more full reports.",
      guestExhausted: "You've used your free trial. Register for free to unlock more full reports.",
      userRemaining: "You still have {n} free detailed analyses.",
      userExhausted: "You've used up your free reports. Get a new report for €1.99 or upgrade to Premium for unlimited full reports.",
      creditsRemaining: "You have {n} report credit(s) available. Go Premium to stop topping up.",
      registerCta: "Register",
      unlockCta: "Unlock",
      upgradeCta: "Premium",
      premiumActive: "Premium · Unlimited reports",
    },
    plan: {
      eyebrow: "Account",
      title: "My plan",
      sub: "Overview of your current plan, reports consumed and upgrade / renewal options.",
      loading: "Loading your plan…",
      gateMessage:
        "Sign in to your account to view your plan details, available reports and any credits you've purchased.",
      freeEyebrow: "Current plan",
      freeTitle: "Free plan",
      freeSub: "3 detailed reports free; additional ones are available as credits or via Premium.",
      reportsRemaining: "Reports still available",
      creditsAvailable: "credit(s)",
      exhaustedWarn:
        "You've used your 3 free reports. Buy a single credit at €1.99 or upgrade to Premium for unlimited reports.",
      premiumActiveEyebrow: "Active plan",
      premiumActiveTitle: "Premium plan",
      premiumActiveSub: "Unlimited reports and downloadable PDFs for the duration of your subscription.",
      expires: "Expires on",
      daysLeft: "days left",
      expiresToday: "Expires today",
      upgradeSection: "Upgrade options",
      renewSection: "Renew your plan",
      renewBadge: "Renewal",
      renewCta: "Renew Premium",
      reportsUsed: "Reports used",
      creditsBalance: "Credits balance",
      daysLeftShort: "Days left",
      freeRemainingShort: "Free remaining",
    },
    paywall: {
      eyebrow: "Unlock unlimited reports",
      title: "Need another report?",
      sub: "Buy a single credit or step up to Premium — ideal for small investors and agents reviewing dozens of listings a day.",
      guestEyebrow: "You've used your free trial",
      guestTitle: "Register free · 3 extra reports",
      guestSub: "Create a free account (Google login) and instantly unlock 3 additional detailed reports — no card needed.",
      registerFreeCta: "Register Free",
      creditEyebrow: "Single credit",
      creditTitle: "1 detailed report",
      creditSub: "Unlocked instantly · Downloadable PDF",
      creditUnit: "one-time",
      creditCta: "Buy 1 report",
      premiumBadge: "Recommended",
      premiumEyebrow: "Premium plan",
      premiumTitle: "Unlimited reports · 30 days",
      premiumSub: "For investors and agents · All downloadable PDFs",
      premiumUnit: "/ month",
      premiumCta: "Go Premium",
      loading: "Redirecting…",
      failed: "Could not start the payment. Try again.",
      loginFirst: "Sign in before purchasing credits or Premium.",
      footer: "Secure payment via Stripe · Cancel anytime via the Customer Portal.",
    },
    billing: {
      eyebrow: "Payment",
      checking: "Verifying your payment…",
      successCredit: "Payment successful. 1 report credit added.",
      successPremium: "Premium unlocked. Unlimited reports for 30 days.",
      cancelled: "Payment cancelled.",
      expired: "Payment session expired. Please try again.",
      missingSession: "Missing session id.",
      stillPending: "Payment is still processing. Check your confirmation email.",
      failed: "Could not verify payment.",
      backHome: "Back to home",
    },
  },
};

export function t(lang, path) {
  const parts = path.split(".");
  let node = translations[lang] || translations.it;
  for (const p of parts) {
    node = node?.[p];
    if (node === undefined) return path;
  }
  return node;
}
